import { UserActivityType, UserEventType, } from '../types/userEvent.interface.d';
export const userEventTypeToString = (userEvent) => {
    switch (userEvent.eventType) {
        case UserEventType.signup:
            return userEvent.byUserId === userEvent.forUserId
                ? 'Client signup'
                : 'Client added';
        case UserEventType.activated:
            return 'Client activated';
        case UserEventType.note:
            return 'Note added';
        case UserEventType.editProfile:
            return 'Profile edited';
        case UserEventType.deactivated:
            return 'Client completed';
        case UserEventType.photoUpload:
            return 'Photo uploaded';
        case UserEventType.photoDeleted:
            return 'Photo deleted';
        case UserEventType.foodImported:
            return 'Food imported';
        case UserEventType.foodCreated:
            return 'Food created';
    }
};
export const activityTypeToString = (userActivityType) => {
    switch (userActivityType) {
        case UserActivityType.reg:
            return 'Reg call';
        case UserActivityType.coaching:
            return 'Coaching call';
        case UserActivityType.referral:
            return 'Referral call';
        case UserActivityType.success:
            return 'Success';
        case UserActivityType.other:
            return 'other';
    }
};
